import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuthStore } from '@/app/store/auth.store';
import { usePermissionSync } from '@/shared/hooks/usePermissionSync';

export function ProtectedRoute() {
  const location = useLocation();
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  const mustChangePassword = useAuthStore((s) => s.mustChangePassword);
  // SHCT-629 — every protected page passes through here, so this is the one
  // place that re-reads the permission map on navigation. Must sit above the
  // early returns below (rules of hooks); it no-ops when unauthenticated.
  usePermissionSync();
  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }
  // Temp password issued by an admin → user must finish the forced reset before
  // reaching any protected page. The login redirect alone is bypassable by
  // editing the URL, so enforce it on every protected route here. The
  // /reset-password route lives outside this guard, so there is no redirect loop.
  if (mustChangePassword) {
    return <Navigate to="/reset-password?mode=forced" replace />;
  }
  return <Outlet />;
}
